import createModel from 'utils/model'
import {list, followUsers} from 'crm/services/duplicate-customer'

function getInitialParams() {
    return {
        keyword: undefined, // 姓名
        user_id: undefined, // 员工id
        limit: 20,
        offset: 0,
    }
}

export default createModel({
    namespace: 'crm_duplicateCustomer',
    state: {
        params: getInitialParams(),
        list: [],
        total: 0,
        activeItem: {},
        followUsers: [],
    },

    subscriptions: {},

    effects: {
        *list({payload}, {call, select, put}) {
            const {params, list: customers} = yield select(
                ({crm_duplicateCustomer}) => crm_duplicateCustomer,
            )
            const query = {...params, ...payload}
            const res = yield call(list, query)
            const data = res?.data || []
            const pagination = res?.pagination || {}
            const currentData = query.offset === 0 ? data : customers.concat(data)
            const currentOffset = pagination.offset

            yield put({
                type: 'setProperty',
                payload: {
                    params: {...query, offset: currentOffset},
                    list: currentData,
                    activeItem: currentData?.length ? currentData[0] : {},
                    total: pagination?.rows_found || 0,
                },
            })
            return res
        },
        *followUsers({payload}, {call, put}) {
            const res = yield call(followUsers, payload)
            if (res && res.data) {
                yield put({
                    type: 'setProperty',
                    payload: {
                        followUsers: res.data,
                    },
                })
            }
        },
    },

    reducers: {
        resetParams(state) {
            return {...state, params: getInitialParams()}
        },
    },
})
